<template>
  <v-layout class="retrieveLoginId" data-qa="retrieveloginid-layout-cmnhw9">
    <v-overlay v-if="loaderEnabled" :opacity="0.5" data-qa="retrieveloginid-overlay-mz7p6j">
      <v-progress-circular
        :color="primaryColor"
        :size="70"
        :width="7"
        indeterminate
        class="circular-loader"
       data-qa="retrieveloginid-progress-circular-qokl4"></v-progress-circular>
    </v-overlay>
    <v-flex v-if="showInputFields" xs12 sm12 md12 lg12 xl12 data-qa="retrieveloginid-flex-2fs6ub">
      <!-- <font class="subtitle-2 font-weight-medium">{{
        $t("login.retrieveLoginId.formHeadline")
      }}</font> -->
      <!--Form Tabs Control-->
      <v-tabs
        v-if ="showCustomerTypeTabs"
        v-model="customerTypeCurrentTab"
        @change="handleCustomerTypeTabChange"
        :color="primaryColor"
       data-qa="retrieveloginid-tabs-axhmxr">
        <v-tab v-for="(item, i) of customerTypeTabLabels" :key="i" :data-tab="item.label" :data-qa="`retrieveloginid-tab-lq11r8-${i}`">
          <!-- <v-icon
            dark
            left
            :data-qa="`retrieveloginid-icon-oym8a-${i}`">
            {{ item.icon }}
          </v-icon> -->
          <dob-icon :iconKey="item.icon" dark left/>
          <font class="subtitle-1 text-capitalize font-weight-bold">{{
            item.label
          }}</font>
        </v-tab>
      </v-tabs>
      <v-card-subtitle data-qa="retrieveloginid-card-subtitle-j0vpn4b">
        {{ currentSubTitle }}
      </v-card-subtitle>
      <v-tabs
        v-if="showParamTypeTabs"
        v-model="currentTab"
        @change="handleParamTypeTabChange"
        :color="primaryColor"
        dense
       data-qa="retrieveloginid-tabs-nw3rst">
        <v-tab v-for="(item, i) of tabLabels" :key="i" :data-tab="item" :data-qa="`retrieveloginid-tab-icl68s-${i}`">
          <font class="subtitle-1 text-capitalize font-weight-bold">{{
            item
          }}</font>
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="currentTab" data-qa="retrieveloginid-tabs-items-lmb0i8">
        <v-tab-item data-qa="retrieveloginid-tab-item-jobppa">
          <v-flex xs12 sm12 md10 lg10 xl10 data-qa="retrieveloginid-flex-3g1uve">
            <Form
              :config="{
                label: '',
                name: 'ForgotLoginID',
                isEnabled: true,
                toolbar: false,
                form: schema.forgotLoginIdDetails,
              }"
            ></Form>
          </v-flex>
        </v-tab-item>
        <v-tab-item data-qa="retrieveloginid-tab-item-1pzvhe">
          <v-flex xs12 sm12 md10 lg10 xl10 data-qa="retrieveloginid-flex-k6u0en">
            <Form
              :config="{
                label: '',
                name: 'ForgotLoginID',
                isEnabled: true,
                toolbar: false,
                form: schema.forgotLoginIdDetails,
              }"
            ></Form>
          </v-flex>
        </v-tab-item>
      </v-tabs-items>
    <v-flex class="d-flex justify-start" data-qa="retrieveloginid-flex-ahw6zj">
      <v-card-actions data-qa="retrieveloginid-card-actions-p0ltn">
        <v-spacer data-qa="retrieveloginid-spacer-chb2w"  />
        <!-- partySearch onNext isPhoneNumberRegistered-->
        <v-btn
          id="nextBtn"
          @click="proceedOnNext"
          :color="primaryColor"
          :disabled="enableNext || !dataModel.phoneNumber"
          style="margin-left: 32px;"
          class="text-capitalize font-weight-bold white--text py-2 px-4"
           data-qa="retrieveloginid-btn-xbr4mfu">{{ $t("login.retrieveLoginId.button.nextBtn") }}</v-btn
        >
      </v-card-actions>
    </v-flex>
    </v-flex>

    <!-- OTP Section -->
    <Modal
      v-if="showOTPSection"
      :config="modalConfig.otp"
      @cancel="onOtpModalClose"
    >
      <span slot="modalContent" data-qa="retrieveloginid-span-0fli4o">
        <OtpInput :otpConfig="otpSettings" />
      </span>
    </Modal>

    <v-flex v-if="showLoginIdSentStatus" xs11 sm11 md11 lg12 xl12 data-qa="retrieveloginid-flex-djijjd">
      <p data-qa="retrieveloginid-p-vc2ag6">
        <inline-svg
          v-if="userId"
          :src="getTickIcon()"
          width="90"
          height="90"
          aria-label="Tick Icon"
          data-qa="pwd-success"
        ></inline-svg>
        <v-icon
          v-else
          size="50"
          :color="errorColor"
          data-qa="pwd-failure"
          >{{ loginIdFoundStatusIcon }}</v-icon
        >
      </p>
      <!-- <p data-qa="retrieveloginid-p-l4qge"><font class="subtitle-1 font-weight-medium">{{ loginIdSentStatus }}</font></p> -->
      <p v-if="userId" class="subtitle-1 font-weight-medium" data-qa="retrieveloginid-p-u2id68">
        {{ $t('login.retrieveLoginId.retrieveLoginIdConfirmMsg') }}
      </p>
      <v-card-actions class="pa-0" data-qa="retrieveloginid-card-actions-ot1gm">
        <v-btn
          @click="goBackToLoginScreen"
          :color="primaryColor"
          data-qa="savePassword"
          class="text-capitalize white--text py-2 px-4"
          >{{ $t("common.goToLoginLabel") }}</v-btn
        >
      </v-card-actions>
    </v-flex>
  </v-layout>
</template>

<script>
import { required } from '@/core/_helpers/validationRules'
import event from '@/util/event'
import OtpInput from '@/components/common/OtpInput.vue'
import CommonService from '@/service/commonService.js'
import getFormConfig from '@/util/formUtility.js'
import '@/styles/components/retrieveLoginId.scss'
import moment from 'moment'
import preLoginMixin from '@/core/mixins/preloginScreensMixin'

export default {
  name: 'RetrieveLoginId',
  components: {
    OtpInput,
    Form: () => import('@/components/DOB-Form/Form.vue'),
    Modal: () => import('@/components/common/Modal.vue')
  },
  mixins: [preLoginMixin],
  data () {
    return {
      enableNext: true,
      showInputFields: true,
      showOTPSection: false,
      showLoginIdSentStatus: false,
      isPhoneNumberRegistered: false,
      allFieldsAreValid: false,
      loaderEnabled: false,
      isSmeCustomerEnabled: false,
      loginIdSentStatus: '',
      loginIdFoundStatusIcon: '',
      userId: '',
      currentTab: 0,
      tabLabels: [
        this.$t('login.retrieveLoginId.tabLabels.customerId'),
        this.$t('login.retrieveLoginId.tabLabels.accNumber')
      ],
      actionConfig: {
        userInfo: {
          userName: 'Roger Moore'
        },
        close: this.onCancelClick
      },
      schema: {
        forgotLoginIdDetails: {
          exists: true
        }
      },
      modalConfig: {
        otp: {
          enabled: false,
          persistent: true,
          enableSave: true,
          close: true,
          saveButton: '',
          outlinedSaveBtn: false,
          title: this.$t('otp.toolBarTitle'),
          width: 400
        }
      },
      currentSubTitle: '',
      showCustomerTypeTabs: false,
      customerTypeTabLabels: [
        { icon: 'retrieveloginid_personaltab', label: 'Personal' },
        { icon: 'retrieveloginid_smetab', label: 'SME' }
      ],
      customerTypeCurrentTab: 0,
      isCustomerParamEnabled: false,
      showParamTypeTabs: false,
      enableOTP: this.$appSettings.defaultConfigurations.loginPageScreens.retrieveLoginIdScreen.enableOTP,
      loginMode: this.$appSettings.defaultConfigurations.loginPageScreens.retrieveLoginIdScreen.userModeTabs,
      paramType: this.$appSettings.defaultConfigurations.loginPageScreens.retrieveLoginIdScreen.customerIdOrAccountNumberTabs,
      defaultSelectedLoginMode: this.$appSettings.defaultConfigurations.loginPageScreens.defaultSelectedLoginMode,
      otpSettings: {
        resetPasswordTime: this.$appSettings.defaultConfigurations.otpResendTimeInterval,
        flex: 'xs12 sm12 md12 lg12 xl12',
        fromScreen: 'retrieveLoginId'
      },
      dataModel: {},
      IBANAccountFormatEnabled: this.$appSettings.defaultConfigurations.loginPageScreens.retrieveLoginIdScreen.enableIBANAccountFormat,
      isdCodeSelectionDisabled: this.$appSettings.defaultConfigurations.loginPageScreens.retrieveLoginIdScreen.disableISDCodeSelection
    }
  },
  async created () {
    this.currentSubTitle = this.$t('login.actionScreen.subHeadings.forgotLoginIdLabel')
    this.loaderEnabled = true
    this.setTabs()
    await this.getFormData(`ForgotLoginID-${this.$i18n.locale}`)
    this.loaderEnabled = false
    event.$on('isValid', (arg) => {
      this.enableNext = !arg
    })
    event.$on('checkLoginScreenAction', (arg) => {
      arg && this.formMethods(arg)
    })
    event.$on('IS_OTP_VALID', (valid) => {
      if (valid && this.showOTPSection && this.enableOTP) {
        this.modalConfig.otp.enabled = false
        this.onOTPVerification()
      } else {
        this.modalConfig.otp.enableSave = true
      }
    })
    event.$on('retrieve_Login_Id', async (data) => {
      await this.findUserByMobile(data)
    })
    event.$on('retrieveLoginId_via', (channel) => {
      if (channel === 'mobile') {
        this.loginIdSentStatus = this.$t(
          'login.retrieveLoginId.confirmationToMobile'
        )
      } else {
        this.loginIdSentStatus = this.$t(
          'login.retrieveLoginId.confirmationToEmail'
        )
      }
      this.onLoginIdSent()
    })
  },
  methods: {
    getTickIcon () {
      return this.getSvgIconSrc('Tick')
    },
    async getFormData () {
      try {
        this.loaderEnabled = true
        const componentSchema = await CommonService.getFormData(
          `ForgotLoginID-${this.$i18n.locale}`
        )
        const data = getFormConfig(componentSchema)
        this.schema.forgotLoginIdDetails = data
        this.dataModel = data.model
        const countryCodes = JSON.parse(localStorage.getItem('countryCode')) || []
        this.schema.forgotLoginIdDetails.schema.countryCode.items = JSON.parse(localStorage.getItem('countryCode')) || []
        // Show SME field
        // this.setSMERelatedData(true)
        // Show SME field
        this.setSMERelatedData(true)
        // set national id types
        if (
          this.schema.forgotLoginIdDetails &&
          this.schema.forgotLoginIdDetails.schema.idTypes
        ) {
          const nationalIDType = JSON.parse(
            sessionStorage.getItem('PARTYIDTYPE')
          )
          if (nationalIDType) {
            const nationalIdTypesArr = []
            nationalIDType.forEach((code) => {
              nationalIdTypesArr.push({
                text: code.codeDescription,
                value: code.codeReference
              })
            })

            this.schema.forgotLoginIdDetails.schema.idTypes.items = nationalIdTypesArr
          }
        }
        event.$emit('resetFormValidation', true)
        if (this.$appSettings.defaultConfigurations.countryISDCode && this.$appSettings.defaultConfigurations.defaultCountryCode && countryCodes) {
          this.schema.forgotLoginIdDetails.schema.countryCode['item-value'] = (item) => `${item.dial_code}_${item.code}`
          const { countryISDCode, defaultCountryCode } = this.$appSettings.defaultConfigurations
          this.schema.forgotLoginIdDetails.model.countryCode = `${countryISDCode}_${defaultCountryCode}`
        }
        if (this.isdCodeSelectionDisabled) this.schema.forgotLoginIdDetails.schema.countryCode.disabled = true
        this.loaderEnabled = false
      } catch (e) {
        console.log(e)
      }
    },
    /** Set Tabs to display - 'Profile' / 'SME'
     * Display tabs only if default login form selection is 'Both'
    */
    setTabs () {
      const loginMode = this.loginMode.toLowerCase()
      const defaultSelectedLoginMode = this.defaultSelectedLoginMode.toLowerCase()
      switch (loginMode) {
        case 'sme':
          this.showCustomerTypeTabs = false
          this.isSmeCustomerEnabled = true
          this.customerTypeCurrentTab = 1
          break
        case 'personal':
          this.showCustomerTypeTabs = false
          this.isSmeCustomerEnabled = false
          this.customerTypeCurrentTab = 0
          break
        case 'both':
          this.showCustomerTypeTabs = true
          this.customerTypeCurrentTab = defaultSelectedLoginMode === 'personal' ? 0 : 1
          this.isSmeCustomerEnabled = this.customerTypeCurrentTab === 1
          break
      }
      this.setConfigTabs()
    },
    setConfigTabs () {
      let paramType = ''
      paramType = this.customerTypeCurrentTab === 0
        ? this.paramType.forPersonal.toLowerCase()
        : this.paramType.forSme.toLowerCase()
      switch (paramType) {
        case 'customerid':
          this.currentTab = 0
          this.showParamTypeTabs = false
          this.isCustomerParamEnabled = true
          break
        case 'accountnumber':
          this.currentTab = 1
          this.showParamTypeTabs = false
          this.isCustomerParamEnabled = false
          break
        case 'both':
          this.showParamTypeTabs = true
          this.currentTab = 0
          this.isCustomerParamEnabled = true
          break
      }
    },
    setParamTabs () {
      if (this.currentTab === 0 && this.schema.forgotLoginIdDetails.schema) {
        this.schema.forgotLoginIdDetails.schema.customerID.hidden = false
        this.schema.forgotLoginIdDetails.schema.customerID.rules.push(required('Required'))
        this.schema.forgotLoginIdDetails.schema.accountNumber.hidden = true
        this.schema.forgotLoginIdDetails.schema.accountNumber.rules = []
        this.schema.forgotLoginIdDetails.schema.lastName.hidden = true
        this.schema.forgotLoginIdDetails.schema.lastName.rules = []
        this.schema.forgotLoginIdDetails.schema.countryCode['menu-props'].contentClass = this.customerTypeCurrentTab === 1 ? 'custom-dropdown-sme' : 'custom-dropdown-custId'
      }
      if (this.currentTab === 1 && this.schema.forgotLoginIdDetails.schema) {
        this.schema.forgotLoginIdDetails.schema.lastName.hidden = false
        this.schema.forgotLoginIdDetails.schema.lastName.rules.push(required('Required'))
        this.schema.forgotLoginIdDetails.schema.accountNumber.hidden = false
        this.schema.forgotLoginIdDetails.schema.accountNumber.rules.push(required('Required'))
        this.schema.forgotLoginIdDetails.schema.customerID.hidden = true
        this.schema.forgotLoginIdDetails.schema.customerID.rules = []
        this.schema.forgotLoginIdDetails.schema.countryCode['menu-props'].contentClass = this.customerTypeCurrentTab === 1 ? 'custom-dropdown-sme' : 'custom-dropdown-accNo'
        if (this.accountType === 'IB') this.schema.forgotLoginIdDetails.schema.accountNumber.label = this.$t('internationalPayments.payeeAccNoLabel')
      }
    },
    handleCustomerTypeTabChange () {
      if (this.customerTypeCurrentTab === 0) {
        this.isSmeCustomerEnabled = false
        this.currentSubTitle = this.$t('login.actionScreen.subHeadings.forgotLoginIdLabel')
      } else {
        this.isSmeCustomerEnabled = true
        this.currentSubTitle = this.$t('login.actionScreen.subHeadings.forgotLoginIdLabelSME')
      }
      // Set SME field
      // this.setSMERelatedData()
      this.setParamTabs()
      this.setConfigTabs()
      this.getFormData()
    },
    handleParamTypeTabChange () {
      this.getFormData(`ForgotLoginID-${this.$i18n.locale}`)
      if (this.currentTab === 0) {
        this.isCustomerParamEnabled = true
      } else this.isCustomerParamEnabled = false
    },
    setSMERelatedData () {
      // Show SME field
      if (this.schema.forgotLoginIdDetails.schema && this.schema.forgotLoginIdDetails.schema.smeID) {
        this.schema.forgotLoginIdDetails.schema.smeID.hidden = !this.isSmeCustomerEnabled
        this.isSmeCustomerEnabled ? this.schema.forgotLoginIdDetails.schema.smeID.rules.push(required('Required')) : this.schema.forgotLoginIdDetails.schema.smeID.rules = []
      }
    },
    async onNext (customerIdFromPartySearch) {
      if (this.customerTypeCurrentTab === 1 && this.dataModel.smeID) {
        const customerID = this.currentTab === 1 ? customerIdFromPartySearch : this.dataModel.customerID
        if (await this.validateCustomerRelationDetails(customerID, this.dataModel.smeID)) {
          this.proceed(customerIdFromPartySearch)
        } else {
          this.partyNotFound('invalidDetails')
        }
      } else {
        this.proceed(customerIdFromPartySearch)
      }
    },
    proceed (customerIdFromPartySearch) {
      this.storeData(customerIdFromPartySearch)
      if (this.enableOTP) {
        this.showOTPSection = true
        this.modalConfig.otp.enabled = true
        setTimeout(() => {
          event.$emit('SEND_OTP', true)
        }, 200)
      } else {
        this.onOTPVerification()
      }
    },
    onOtpModalClose () {
      this.modalConfig.otp.enabled = false
      this.modalConfig.otp.enableSave = true
      this.showOTPSection = false
    },
    storeData (customerIdFromPartySearch) {
      this.$store.dispatch('profileStore/setProfileData', {
        partyDetails: {
          customerID: this.dataModel?.customerID || customerIdFromPartySearch,
          dateOfBirth: this.dataModel?.dateOfBirth,
          emailAddress: this.dataModel?.emailAddress,
          firstName: this.dataModel?.firstName,
          lastName: this.dataModel?.lastName,
          idNumber: this.dataModel?.idNumber,
          idTypes: this.dataModel?.idTypes,
          phoneNumber: this.dataModel?.phoneNumber,
          countryCode: this.dataModel?.countryCode?.split('_')[0]
        }
      })
    },
    onOTPVerification () {
      this.findUserByMobile(this.dataModel.phoneNumber)
    },
    goBackToLoginScreen () {
      event.$emit('goBackToLoginScreen', true)
    },
    onCancelClick () {
      this.$emit('loginActionEvent', true)
    },
    formMethods ({ e, action }) {
      if (action === 'blur') {
        switch (e.key) {
          case 'phoneNumber':
            this.checkPhoneValidation()
            break
          default:
        }
      } else if (action === 'input') {
        if (e.key === 'countryCode' && this.dataModel.countryCode && this.dataModel.phoneNumber) this.checkPhoneValidation()
        if (this.dataModel.accountNumber && this.dataModel.accountNumber.length) {
          if (this.accountType === 'IB') {
            this.dataModel.accountNumber = this.dataModel.accountNumber.toUpperCase()
          }
        }
        if (e.key === 'idTypes') {
          if (this.dataModel.idTypes && this.dataModel.idTypes.length) {
            this.schema.forgotLoginIdDetails.schema.idNumber.rules.push(required('Required'))
            // this.schema.forgotLoginIdDetails.schema.idNumber.id.rules.push(required('Required'))
            // this.schema.forgotLoginIdDetails.model.idNumber = undefined
          } else {
            this.schema.forgotLoginIdDetails.schema.idNumber.rules = []
            // this.schema.forgotLoginIdDetails.model.idNumber = undefined
          }
          event.$emit('resetFormValidation', true)
        }

        if (e.key === 'idNumber') {
          if (this.dataModel.idNumber && this.dataModel.idNumber.length) {
            this.schema.forgotLoginIdDetails.schema.idTypes.rules.push(required('Required'))
          } else {
            this.schema.forgotLoginIdDetails.schema.idTypes.rules = []
            // this.schema.forgotLoginIdDetails.model.idTypes = undefined
          }
          event.$emit('resetFormValidation', true)
        }

        switch (e.key) {
          case 'idTypes':
            this.changeIDtype()
            break
          default:
        }
      }
    },
    changeIDtype () {
      this.schema.forgotLoginIdDetails.schema.idNumber.hidden =
        this.dataModel.idTypes === ''
    },
    async checkPhoneValidation () {
      let resp = false
      let isRespAvailable = false
      const cc = this.dataModel?.countryCode?.split('_')[0] || ''
      const body = {
        mobileNumber: cc && this.dataModel.phoneNumber ? `${cc}${this.dataModel.phoneNumber}` : ''
      }
      this.loaderEnabled = true
      if (this.dataModel.phoneNumber && this.dataModel.phoneNumber.length > 4) {
        resp = await CommonService.validatePhoneNumber(body)
        isRespAvailable = true
      } else {
        isRespAvailable = false
      }
      // For Personal -> If response is 'true', phoneNo is registered
      this.isPhoneNumberRegistered = resp === true
      if (isRespAvailable) {
        if (this.isPhoneNumberRegistered) {
          this.schema.forgotLoginIdDetails.schema.phoneNumber.hidden = true
          this.schema.forgotLoginIdDetails.schema.phoneNumber.hidden = false
          this.schema.forgotLoginIdDetails.schema.phoneNumber.error = false
          this.schema.forgotLoginIdDetails.schema.phoneNumber['error-messages'] = ''
        } else {
          this.schema.forgotLoginIdDetails.schema.phoneNumber.hidden = true
          this.schema.forgotLoginIdDetails.schema.phoneNumber.appendIcon = ''
          this.schema.forgotLoginIdDetails.schema.phoneNumber.hidden = false
          this.schema.forgotLoginIdDetails.schema.phoneNumber.error = true
          this.schema.forgotLoginIdDetails.schema.phoneNumber['error-messages'] = this.$t('login.retrieveLoginId.validationStatus.mobileNumberExistence')
        }
      } else this.isPhoneNumberRegistered = false
      this.loaderEnabled = false
    },
    proceedOnNext () {
      if (this.currentTab === 1) {
        this.getAccountDetails()
      } else this.partySearch()
    },
    async getAccountDetails () {
      if (this.currentTab === 1 && this.dataModel.accountNumber) {
        const accDetails = await CommonService.checkAccountStatusFromBff(this.dataModel.accountNumber, this.accountType)
        if (accDetails && accDetails.accountStatus && (['activated', 'normal'].includes(accDetails.accountStatus.toLowerCase()) || (this.allowInactiveAccountPreLoginOperations && accDetails.accountStatus.toLowerCase() === 'inactive'))) {
          this.partySearch()
        } else if ((accDetails && accDetails.causes && accDetails.causes[0]?.code === '40280164') || (accDetails.error && accDetails?.error?.causes && accDetails?.error?.causes[0].code === '40280164')) {
          this.partySearch()
        } else if ((accDetails && accDetails.causes && accDetails.causes[0]?.code === '20600027') || (accDetails.error && accDetails?.error?.causes && accDetails?.error?.causes[0].code === '20600027')) {
          // Prelogin screen - customer is on the blacklist or invalid status
          // this.partyNotFound('pendingVerification')
          this.partySearch()
        } else {
          this.partyNotFound('invalidDetails')
        }
      }
    },
    async partySearch () {
      // Validate user against entered info
      // Party search API call payload
      this.loaderEnabled = true
      let partySearchData = {}
      if (this.currentTab === 0) {
        if (this.dataModel.idNumber && this.dataModel.idTypes) {
          partySearchData = {
            // extra info
            customerId: this.dataModel.customerID,
            schema: this.schema.forgotLoginIdDetails.schema,
            // actual payload
            identifier: this.dataModel.idNumber,
            idType: this.dataModel.idTypes,
            partyType: '1062',
            partyName: this.dataModel.firstName
              ? `${this.dataModel.firstName}%`
              : null,
            dateOfBirthOrFormation: this.dataModel.dateOfBirth ? moment(this.dataModel.dateOfBirth, 'DD-MM-YYYY').format('YYYY-MM-DD') : '',
            mobile: !!this.dataModel.phoneNumber.length > 0 ? this.dataModel.phoneNumber : '',
            email: this.dataModel?.emailAddress?.length > 0 ? this.dataModel.emailAddress : null
          }
        } else {
          partySearchData = {
            // extra info
            customerId: this.dataModel.customerID,
            schema: this.schema.forgotLoginIdDetails.schema,
            // actual payload
            partyName: this.dataModel.firstName
              ? `${this.dataModel.firstName}%`
              : null,
            dateOfBirthOrFormation: this.dataModel.dateOfBirth ? moment(this.dataModel.dateOfBirth, 'DD-MM-YYYY').format('YYYY-MM-DD') : '',
            mobile: this.dataModel.phoneNumber.length > 0 ? this.dataModel.phoneNumber : '',
            email: this.dataModel?.emailAddress?.length > 0 ? this.dataModel.emailAddress : null
          }
        }
      } else {
        if (this.dataModel.idNumber && this.dataModel.idTypes) {
          partySearchData = {
            customerId: this.dataModel.customerID,
            idNumber: this.dataModel.idNumber,
            idType: this.dataModel.idTypes,
            firstName: this.dataModel.firstName,
            lastName: this.dataModel.lastName,
            dateOfBirth: this.dataModel.dateOfBirth ? moment(this.dataModel.dateOfBirth, 'DD-MM-YYYY').format('YYYY-MM-DD') : '',
            mobile: this.dataModel.phoneNumber.length > 0 ? this.dataModel.phoneNumber : '',
            email: this.dataModel?.emailAddress?.length > 0 ? this.dataModel.emailAddress : null,
            accountNumber: this.dataModel.accountNumber,
            accountType: this.accountType
          }
        } else {
          partySearchData = {
            customerId: this.dataModel.customerID,
            firstName: this.dataModel.firstName,
            lastName: this.dataModel.lastName,
            dateOfBirth: this.dataModel.dateOfBirth ? moment(this.dataModel.dateOfBirth, 'DD-MM-YYYY').format('YYYY-MM-DD') : '',
            mobile: this.dataModel.phoneNumber.length > 0 ? this.dataModel.phoneNumber : '',
            email: this.dataModel?.emailAddress?.length > 0 ? this.dataModel.emailAddress : null,
            accountNumber: this.dataModel.accountNumber,
            accountType: this.accountType
          }
        }
      }
      let partyDataValidation
      try {
        partyDataValidation = this.currentTab === 1
          ? await CommonService.partySearchByAccount(partySearchData)
          : await CommonService.partyUserSearch(partySearchData)
      } catch (e) {
        console.log(e)
        this.loaderEnabled = false
      }

      // Empty object or null indicates potential connection drop / backend unreachable
      if (!partyDataValidation || (typeof partyDataValidation === 'object' && Object.keys(partyDataValidation).length === 0)) {
        this.loaderEnabled = false
        return
      }

      if (partyDataValidation?.validationResponse) {
        this.onNext(partyDataValidation?.customerId)
      } else {
        partyDataValidation?.cause
          ? this.partyNotFound(partyDataValidation.cause)
          : this.partyNotFound('invalidDetails')
      }
      this.loaderEnabled = false
    },
    async validateCustomerRelationDetails (customerID, smeID) {
      const checkResp = await CommonService.validateCustomerRelationDetails(customerID, smeID)
      return typeof checkResp === 'boolean' && checkResp === true
    },
    partyNotFound (data) {
      this.$store.dispatch('appStore/setAppData', {
        message: {
          title: 'Error',
          width: 400,
          persistent: true,
          saveButton: this.$t('common.okay'),
          saveCallback: this.resetScreen,
          content: this.$t(`login.retrieveLoginId.validationStatus.${data}`),
          type: 'error',
          component: 'dob-modal'
        }
      })
    },
    async findUserByEmail () {
      try {
        this.loaderEnabled = true
        const payload = {
          emailId: this.dataModel.emailAddress
        }
        const userDetails = await CommonService.findUserByEmail(payload)
        if (userDetails && userDetails.userLoginId) {
          this.userId = userDetails.userLoginId
          this.loginIdFoundStatusIcon = 'mdi-checkbox-marked-circle-outline'
          this.loginIdSentStatus = this.$t(
            'login.retrieveLoginId.confirmationToEmailMobile'
          )
        } else {
          this.loginIdFoundStatusIcon = 'mdi-close-circle-outline'
          this.loginIdSentStatus = this.$t(
            'login.retrieveLoginId.confirmationFailure'
          )
        }
        this.showOTPSection = false
        this.showLoginIdSentStatus = true
        this.loaderEnabled = false
      } catch (e) {
        console.log(e)
      }
    },
    async findUserByMobile ({ otp, referenceNumber }) {
      try {
        this.loaderEnabled = true
        let payload = {
          emailId: this.dataModel.emailAddress || '',
          mobileCountryCode: this.dataModel?.countryCode?.split('_')[0] || '',
          mobilePhoneNumber: this.dataModel.phoneNumber || '',
          userCategoryCode: this.dataModel.smeID ? 'CORPORATE_USER' : 'BANK_CUSTOMER'
        }

        if (this.enableOTP) {
          payload = {
            ...payload,
            otp,
            referenceNumber
          }
        }

        const userDetails = await CommonService.retriveUserLoginId(payload)

        if (userDetails.data && userDetails.data.userFound) {
          this.userId = true
          this.loginIdFoundStatusIcon = 'mdi-checkbox-marked-circle-outline'
          this.loginIdSentStatus = this.$t(
            'login.retrieveLoginId.confirmationToEmailMobile'
          )
          this.showOTPSection = false
          this.showLoginIdSentStatus = true
          this.loaderEnabled = false
          this.showInputFields = false
          event.$emit('resetForm', true)
        } else {
          this.loaderEnabled = false
          if (['11400360', '11400361'].includes(userDetails.error.response.data.causes[0].code)) {
            event.$emit('retrieveLoginId_invalidOtp')
          } else {
            this.loginIdFoundStatusIcon = 'mdi-close-circle-outline'
            this.loginIdSentStatus = this.$t(
              'login.retrieveLoginId.confirmationFailure'
            )
          }
        }
      } catch (e) {
        console.log(e)
      }
    }
  },
  updated () {
    this.setParamTabs()
  },
  watch: {
    currentTab () {
      this.setParamTabs()
    }
  },
  beforeDestroy () {
    event.$off('retrieve_Login_Id')
    event.$off('checkLoginScreenAction')
  }
}
</script>
